<template>
  <div>
    <validation-observer ref="tabIv">
      <custom-collapse class="mt-2" :id="'tab-' + item.id">
        <custom-collapse-item
          :parent-id="'tab-' + item.id"
          :expanded="item.expanded"
          :checked="item.checked"
          :selected="item.selected"
          expanded-icon="fas fa-plus-circle color-black--3"
          @expandButtonClick="expandButtonClicked"
        >
          <template #extraHeaderContent>
            <div class="row">
              <div
                class="col-12 col-md-1 "
                :class="{ 'border-right': !isMobile }"
              >
                <div :class="`badge badge-pill font-16 mt-3 py-2 ml-1`">
                  <span class="font-weight-normal">#</span>
                  <br />
                  <span class="font-weight-bold">
                    {{ (index + 1).toString().padStart(2, '0') }}
                  </span>
                </div>
              </div>
              <div class="col-12 col-md-11">
                <div class="row py-3 m-0">
                  <div class="col-md col-12 col-spacing">
                    <div class="mb-4">
                      <div
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Equipos Requisados:
                      </div>
                      <div class="color-black font-16 font-weight-bold">
                        {{ item.detail.length.toString().padStart(2, '0') }}
                      </div>
                    </div>
                    <div>
                      <div
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Budget Check:
                      </div>
                      <div class="color-black font-16 font-weight-bold">
                        {{ item.budgetStatus | empty }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md col-12 col-spacing mt-2 mt-md-0">
                    <div
                      :class="{
                        'mb-2': canUpdate,
                        'mb-4': !canUpdate,
                      }"
                    >
                      <div
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        <span v-if="canUpdate">
                          Número de Requisición SIFDE:
                        </span>
                        <span v-else>Número de Requisición:</span>
                      </div>
                      <div
                        v-if="!canUpdate"
                        class="color-black font-16 font-weight-bold"
                      >
                        {{ item.requisitionNumber | empty }}
                      </div>
                      <div v-else>
                        <validation-provider
                          rules="required"
                          mode="eager"
                          v-slot="{ errors }"
                          :ref="requisitionNumberRef"
                        >
                          <custom-input
                            name="requisitionNumber"
                            id="requisitionNumberInput"
                            v-model="model.requisitionNumber"
                            :error="errors[0]"
                            :custom-error-msg="''"
                          />
                        </validation-provider>
                      </div>
                    </div>
                    <div>
                      <div
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Hold Status:
                      </div>
                      <div class="color-black font-16 font-weight-bold">
                        {{ item.holdStatus | empty }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 col-spacing mt-2 mt-md-0">
                    <div class="mb-4">
                      <div
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Fecha de Requisición:
                      </div>
                      <div class="color-black font-16 font-weight-bold">
                        {{ formatDate(item.requisitionDate) }}
                      </div>
                    </div>
                    <div>
                      <div
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Request Status:
                      </div>
                      <div class="color-black font-16 font-weight-bold">
                        {{ item.approvalStatus | empty }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-12 col-spacing mt-2 mt-md-0">
                    <div
                      class="color-secondary-6 font-14 font-weight-normal mr-2"
                    >
                      Nombre de la Requisición:
                    </div>
                    <div
                      class="color-black font-16 font-weight-bold text-break"
                    >
                      {{ item.name | empty }}
                    </div>
                  </div>
                  <div
                    class="col-md col-12 col-spacing mt-2 mt-md-0 text-right"
                  >
                    <drop-down :items="actionItems" class="mt-3" />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="bg-white py-3 px-md-3 rounded" v-if="showTabs">
            <requisition-tabs :item="item" :tab-index="0" />
          </div>
          <div class="mt-md-4">
            <add-binnacle
              v-if="showBinnacle"
              :tab-index="1"
              v-model="model.binnacle"
              @cancel="handlerClose"
              @save="handlerAddBinnacle"
            />
          </div>
        </custom-collapse-item>
      </custom-collapse>
    </validation-observer>
    <div v-if="!item.requisitionNumber && item.message" class="row">
      <div class="col px-0">
        <div
          v-if="item.queueStatus == 0"
          class="requistion-row alert alert-warning border-top-0 rounded-bottom"
          role="alert"
        >
          <i
            class="fas fa-hourglass-half fa-flip icon-sand-animate fa-lg mr-3"
          ></i>
          {{ item.message | empty }}
        </div>
        <div
          v-if="item.queueStatus == 1"
          class="requistion-row alert alert-danger border-top-0 rounded-bottom text-danger"
          role="alert"
        >
          <img
            class="rb-loading  mr-3"
            src="@/assets/img/loading.svg"
            alt=""
            srcset=""
          />
          <span class="text-danger">{{ item.message | empty }}</span>
        </div>
        <div
          v-if="item.queueStatus == 2"
          class="requistion-row alert alert-warning border-top-0 rounded-bottom"
          role="alert"
        >
          <i class="fas fa-bell-exclamation fa-lg mr-3"></i>
          {{ item.message | empty }}
        </div>
      </div>
    </div>
    <div class="row" v-if="item.requisitionNumber && item.queueStatus == 2">
      <div class="col px-0">
        <div
          class="requistion-row alert alert-success border-top-0 rounded-bottom"
          role="alert"
        >
          <i class="fas fa-check-circle fa-lg mr-3 text-success"></i>
          <span class="text-success">{{ item.message | empty }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomInput from 'CustomInput';
import moment from 'moment';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import DropDown from 'dropdown';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import apiService from '@/services/api/requisitionmanagment.api';
import mixAlert from '@/mixins/alert.mixin';
import AddBinnacle from '../../referralAndEquipment/components/AddBinnacle.vue';
import { serialize as objectToFormData } from 'object-to-formdata';
import RequisitionTabs from './RequisitionTabs.vue';

const DETAILS_TABS = { Tabs: 0, Binnacle: 1 };
const QueueStatus = { Pending: 0, InProcess: 1, Completed: 2 };

export default {
  name: 'RequisitionRow',
  components: {
    CustomInput,
    CustomCollapse,
    CustomCollapseItem,
    DropDown,
    AddBinnacle,
    RequisitionTabs,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        detail: [],
      }),
    },
    index: {
      type: Number,
      required: true,
    },
    peiAtServiceId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    expandedIndex: DETAILS_TABS.Tabs,
    model: {
      requisitionNumber: null,
      binnacle: {},
      documentDate: {},
    },
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    actionItems() {
      return [
        {
          name: 'Sincronizar',
          icon: 'fas fa-redo text-success',
          click: () => this.handlerSync(),
          visible:
            this.userHasPermissions(
              'technologyassistance.requisitions.updaterequisitioninfo'
            ) &&
            this.item.approvalStatus != 'X' &&
            !!this.item.requisitionNumber,
        },
        {
          name: 'Actualizar',
          icon: 'fas fa-refresh text-success',
          click: () => this.handlerUpdate(),
          visible: this.canUpdate,
        },
        {
          name: 'Añadir Bitácora',
          icon: 'far fa-comment text-green',
          border: 'bottom',
          click: () => this.expand(DETAILS_TABS.Binnacle),
        },
        {
          name: 'Remover',
          icon: 'fas fa-trash text-success',
          click: () => this.handlerDelete(),
          visible: this.canDelete,
        },
        {
          name: 'Ver Equipos',
          icon: 'fas fa-laptop text-success',
          click: () => this.expand(DETAILS_TABS.Tabs),
        },
      ];
    },
    showBinnacle() {
      return this.expandedIndex === DETAILS_TABS.Binnacle;
    },
    showTabs() {
      return this.expandedIndex == DETAILS_TABS.Tabs;
    },
    canUpdate() {
      return (
        !this.item.requisitionNumber &&
        this.item.queueStatus === QueueStatus.Completed &&
        this.item.transactionStatus != 'E' &&
        this.userHasPermissions(
          'technologyassistance.requisitions.updaterequisitioninfo'
        )
      );
    },
    canDelete() {
      return (
        !this.item.requisitionNumber &&
        this.item.transactionStatus == 'E' &&
        this.item.queueStatus === QueueStatus.Completed
      );
    },
    requisitionNumberRef() {
      return `rn-${this.item.id}`;
    },
  },
  async mounted() {},
  methods: {
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    expandButtonClicked() {
      this.expandedIndex = DETAILS_TABS.Tabs;
      this.item.expanded = !this.item.expanded;
    },
    expand(index) {
      this.expandedIndex = index;
      this.item.expanded = true;
    },
    handlerClose() {
      this.item.expanded = false;
    },
    async handlerSync() {
      const { data } = await apiService.sync(this.item.id, this.peiAtServiceId);

      this.ShowToast('Éxito', data, 'success');
      this.$emit('reload');
    },
    async handlerUpdate() {
      const { valid } = await this.$refs[this.requisitionNumberRef].validate();
      if (!valid) {
        this.ShowToast(
          'Error',
          'Es requerido que se documente el campo de Número de Requisición SIFDE.',
          'error'
        );
        return;
      }

      try {
        await apiService.update(this.item.id, { ...this.model });

        this.ShowToast(
          'Éxito',
          'Información ha sido actualizada exitosamente.',
          'success'
        );
        this.$emit('reload');
      } catch {
        this.ShowToast(
          'Error',
          'Ha ocurrido un error al editar el número de requisición',
          'error'
        );
      }
    },
    async handlerDelete() {
      try {
        await apiService.delete(this.item.id);

        this.ShowToast(
          'Éxito',
          'Información ha sido eliminada exitosamente.',
          'success'
        );
        this.$emit('reload');
      } catch {
        this.ShowToast(
          'Error',
          'Ha ocurrido un error al editar el número de requisición',
          'error'
        );
      }
    },
    async handlerAddBinnacle() {
      const payload = objectToFormData({
        ...this.model.binnacle,
        peiAtServiceRequisitionId: this.item.id,
      });

      const { data } = await apiService.saveBinnacle(payload).catch((error) => {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      });
      if (data) {
        this.model.binnacle = {
          attachment: null,
          attachmentId: null,
          comment: null,
          documentName: null,
        };
        this.ShowToast(
          'Éxito',
          'Se ha guardado la bitácora correctamente',
          'success'
        );
        this.handlerClose();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .dot {
  padding: 19px !important;
}

.requistion-row.alert {
  border-radius: initial;
  color: #af6708;
}

.rb-loading {
  -webkit-animation: spin 4s linear infinite;
  -moz-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media (min-width: 1400px) {
  .m-right {
    margin-right: 5rem !important;
  }
}

.icon-sand-animate {
  --fa-flip-x: 1;
  --fa-flip-y: 0;
  --fa-animation-duration: 2s;
}
</style>
